import React, { useEffect, useState } from 'react'
import RejectionChartWithoutControls from '../../components/RejectionDoughnut/RejectionChartWithoutControls'
import { showNotification } from '../../utils/toast.utils'
import { getFiRejectionReasonDoughnut } from '../../service/fiRejectionReason.service'
import StyledSelectField from '../../components/StyledSelectField/StyledSelectField'

const RejectionWrapperMachineWise = ({ selectedDate, selectedShift }) => {
  const defaultPartFamily = { label: 'All part numbers', value: 'all' }

  const [isLoading, setIsLoading] = useState(false)
  const [rejectionData, setRejectionData] = useState({})
  const [selectedPartFamily, setSelectedPartFamily] =
    useState(defaultPartFamily)

  const [availablePartFamilyShiftWise, setAvailablePartFamilyShiftWise] =
    useState({})

  useEffect(() => {
    const fetchDoughnutData = async () => {
      try {
        setIsLoading(true)

        const params = {}
        if (selectedDate) params.date = selectedDate

        const response = await getFiRejectionReasonDoughnut(params)

        if (!response.data.success) {
          showNotification('Failed to fetch data', 'error')
          return
        }

        const data = response.data.data.rejectionMachineWiseData.overall
        setRejectionData(data)

        const partFamilyMap = { S1: [], S2: [], S3: [], day: [] }

        Object.keys(data).forEach((shiftKey) => {
          Object.keys(data[shiftKey]).forEach((partFamily) => {
            if (!partFamilyMap[shiftKey].includes(partFamily)) {
              partFamilyMap[shiftKey].push(partFamily)
            }
            if (!partFamilyMap.day.includes(partFamily)) {
              partFamilyMap.day.push(partFamily)
            }
          })
        })

        setAvailablePartFamilyShiftWise(partFamilyMap)
        setSelectedPartFamily(defaultPartFamily)
      } catch (err) {
        console.error(err)
        showNotification('Error fetching doughnut data', 'error')
      } finally {
        setIsLoading(false)
      }
    }

    fetchDoughnutData()
  }, [selectedDate])

  if (isLoading) return <>Loading...</>

  const shiftKey =
    selectedShift && selectedShift.value !== 0 ? selectedShift.value : 'day'

  const shiftData = rejectionData[shiftKey] || {}

  let finalData = {}

  if (selectedPartFamily.value === 'all') {
    finalData = shiftData
  } else {
    finalData = {
      [selectedPartFamily.value]: shiftData[selectedPartFamily.value] || {}
    }
  }

  const selectOptions = [
    defaultPartFamily,
    ...(availablePartFamilyShiftWise[shiftKey] || []).map((pf) => ({
      label: pf,
      value: pf
    }))
  ]

  return (
    <>
      {Object.keys(finalData).length > 0 ? (
        <RejectionChartWithoutControls
          rejectionData={finalData}
          selectionComponent={
            <StyledSelectField
              label=""
              placeHolderText="Select part number"
              selectedValue={selectedPartFamily}
              selectOptions={selectOptions}
              onChangeHandler={(value) => setSelectedPartFamily(value)}
              isMulti={false}
              isSearchable={true}
              isDisabled={false}
              noOptionsMessage="No part number found"
            />
          }
        />
      ) : (
        <p>No data available for the selected shift.</p>
      )}
    </>
  )
}

export default RejectionWrapperMachineWise
